import React from 'react';
import styled from 'styled-components';

import Header from './components/Header';
import Content from './components/Content';
import Socials from './components/Socials';
import MorePosts from './components/MorePosts';

function SinglePostDealerWeb() {
  return (
    <Component>
      <Header />
      <Content />
      <Socials />
      <MorePosts />
    </Component>
  );
}

export default SinglePostDealerWeb;

const Component = styled.section`
  flex: 1;
  display: flex;
  flex-direction: column;
`;
